import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger
} from '@fluentui/react-components';
import { IBasicInfoPopupProps } from './BasicInfoPopup.types';
import { useBasicInfoPopupStyles } from './BasicInfoPopup.styles';

const BasicInfoPopup = (props: IBasicInfoPopupProps) => {
    const { showPopup, popupHeader, popupText, setPopup, children } = props;
    const styles = useBasicInfoPopupStyles();

    return (
        <Dialog open={showPopup}>
            <DialogSurface className={styles.basicInfoPopup}>
                <DialogBody>
                    <DialogTitle as='h2' className={styles.header}>
                        {popupHeader}
                    </DialogTitle>
                    <DialogContent>
                        <p>{popupText}</p>
                        {children}
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger>
                            <Button onClick={() => setPopup(false)} className={styles.button}>
                                Close
                            </Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default BasicInfoPopup;
